import profilePhoto from '../img/profile-photo.webp';
import './About.scss';
import Pills from '../components/pills/Pills';

export default function Home() {
  const skills = ["HTML", "SCSS", "React", "Angular", "TypeScript", "Storybook"];
  return (
    <section className="about">
      <div className="anchor" id="about"></div>
      <div className="row center-xs">
        <div className="col-xs-12 col-md-6">
          <div className="card">
            <div className="profile-photo">
              <img src={profilePhoto} alt="Victoria sitting at her desk" width="100%" height="100%" />
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-md-6">
          <div className="card">
            <h2>About me</h2>
            {/* <p className="margin-bottom-40">
              Hello, my name is Victoria, I am an experienced frontend developer who loves creating beautiful, responsive and user-friendly web applications.
              I am passionate about tackling complex assignments and turning them into elegant solutions through code.
              I aim to deliver pleasing results by building pixel-perfect interfaces, working closely with designers in order to bring their ideas to life, and optimizing the performance of the apps I work on.
            </p> */}
            <p className='margin-bottom-18'>
              Hello, my name is Victoria, I am an experienced frontend developer who loves creating beautiful, responsive and user-friendly web applications. My favorite technologies to use are:
            </p>
            <div className='align-center margin-bottom-40'>
              <Pills pills={skills}></Pills>
            </div>
            <p className="margin-bottom-40">
              In my career so far, I've had the opportunity to work for a number of large companies where I've gained a great variety of skills and have proven to be a valuable addition to any development team. Find out more about my work experience in the <a href="#experience">timeline below</a>.
            </p>
            <p className="margin-bottom-40">
              In my free time, I love to bake and decorate cakes, cupcakes and other desserts. I also enjot visiting theme parks, traveling to fun places and playing video games.
            </p>
            <p className="margin-bottom-40">
              Keep scrolling in order to find out more about my <a href="#experience">work experience</a> and <a href="#interests">interests</a>. For questions, feel free to reach out by using the <a href="#contact">contact form</a> at the bottom of the page.
            </p>
            {/* <p className="margin-bottom-40">
              In my career so far, I've had the opportunity to work for a number of large and well-known companies where I've gained a great variety of skills and have been able to
              prove my ability to complete projects within the deadline and leave stakeholders happy with the final result.
              I operate with a noticeable sense of direction, thrive under pressure, and meet goals considerably better when working in a productive and challenging environment.
            </p>
            <p className="margin-bottom-40">
              In my free time, I enjoy baking and decorating cakes, cupcakes and other desserts. I also love to visit theme parks, play video games and enjoy working on my calligraphy skills.
              My most recent hobby is creating quilling paper art, which lets me relax and spend some time away from the computer.
              I've also had the chance in the past few years to travel more and visit some cool places, and I'm looking forward to traveling more in the future.
            </p>
            <p className="margin-bottom-40">
              Keep scrolling in order to find out more about me, my work experience, skills and interests. For any questions feel free to reach out by using the contact form at the bottom of the page.
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
}